import { render, staticRenderFns } from "./toolbar-button.vue?vue&type=template&id=15fbc011&scoped=true&"
import script from "./toolbar-button.vue?vue&type=script&lang=js&"
export * from "./toolbar-button.vue?vue&type=script&lang=js&"
import style0 from "./toolbar-button.vue?vue&type=style&index=0&id=15fbc011&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fbc011",
  null
  
)

component.options.__file = "toolbar-button.vue"
export default component.exports